import { Routes, RouterModule } from '@angular/router';
import { loggedInAuthGuard } from '@guards/logged-in-auth.guard';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./features/home/home/home.component').then((m) => m.HomeComponent),
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: 'inactivity',
    loadComponent: () =>
      import('./features/inactivity/inactivity.component').then(
        (m) => m.InactivityComponent,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
